import { useState, createContext, useContext, useEffect } from "react";
import { logoutAction } from "../services/login.service";
import {
  storeDataInLocalStorage,
  getDataFromLocalStorage,
} from "../utils/localStorage";

declare global {
  interface Window {
    logout(): void;
  }
}

type AuthStateType = {
  accessToken: string;
  refreshToken: string;
  data: {
    firstName: string;
    lastName: string;
  };
};

type AuthContextType = {
  user: AuthStateType | null;
  login(user: AuthStateType): void;
  logout(): void;
};

type AuthProviderProps = {
  children: React.ReactNode;
};

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const data = getDataFromLocalStorage("user");
  const [user, setUser] = useState<AuthStateType | null>(data);

  const login = (user: AuthStateType) => {
    storeDataInLocalStorage("user", user);
    setUser(user);
  };

  const logout = () => {
    logoutAction(setUser);
  };

  useEffect(() => {
    window.logout = logout;
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
